exports.wrongInput = "redInput";
exports.adminUserMenu = [
  {
    name: "Přidat produkt",
    slug: "addproduct"
  },
  {
    name: "Upravit kategorie",
    slug: "addcategory"
  },
  {
    name: "Objednávky",
    slug: "orders"
  },
  {
    name: "Nastavení",
    slug: "settings"
  },
  {
    name: "Odlásit",
    slug: "logout"
  }
];
exports.userMenu = [
  {
    name: "Objednávky",
    slug: "orders"
  },
  {
    name: "Košík",
    slug: "cart"
  },
  {
    name: "Odhlásit",
    slug: "logout"
  }
];
exports.loginMenu = [
  {
    name: "Registrovat",
    slug: "signup"
  },
  {
    name: "Přihlásit",
    slug: "login"
  }
];
exports.fetchParams = (method, body) => {
  let params = {
    method: method,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'pragma': 'no-cache'
    },
    credentials: 'include',
  };
  if(typeof body !== "undefined") {
    params.body = JSON.stringify(body);
  }
  return params;
}



// WEBPACK FOOTER //
// ./src/lib/settings.js